import { ActionWithPayload, RehydrateOptions } from "@obg/ngrx-utils";
import { fromDaysToMilliseconds, updateState } from "@obg/ngx.global";

import { COOKIE_NOTICE_ACTION_TYPE } from "./cookie-notice.action";
import { CookieNoticeState } from "./cookie-notice.model";

const INITIAL_STATE: CookieNoticeState = {
	isClosed: false,
	isVisible: false,
	isEnabled: undefined,
};

export function cookieNoticeReducer(state = INITIAL_STATE, action: ActionWithPayload): CookieNoticeState {
	switch (action.type) {
		case COOKIE_NOTICE_ACTION_TYPE.setEnabled: {
			return updateState(state, { isEnabled: action.payload });
		}
		case COOKIE_NOTICE_ACTION_TYPE.close: {
			return updateState(state, {
				isClosed: true,
				isVisible: false,
			});
		}

		case COOKIE_NOTICE_ACTION_TYPE.show: {
			return updateState(state, { isVisible: true });
		}
		default:
			return state;
	}
}

const ONE_YEAR_IN_MS = fromDaysToMilliseconds(365);
cookieNoticeReducer.prototype.rehydrateOptions = (): RehydrateOptions<CookieNoticeState> => ({
	name: "cookieNoticeReducer",
	maxAge: ONE_YEAR_IN_MS,
	excludeProps: ["isVisible", "isEnabled"],
});
